app.service('emailRepliesService', function ($http) {

  // { source, status, since, limit, include_body }
  this.list = function (obj) {
    return $http.post(`/emailReplies/list`, obj)
      .then(function (response) {
        return response
      })
  }

  // { id }
  this.get = function (obj) {
    return $http.post(`/emailReplies/get`, obj)
      .then(function (response) {
        return response
      })
  }

  // { id | ids, status }
  this.updateStatus = function (obj) {
    return $http.post(`/emailReplies/updateStatus`, obj)
      .then(function (response) {
        return response
      })
  }

})
